import { render, staticRenderFns } from "./CampaignStats.vue?vue&type=template&id=4c45d4f0&scoped=true&"
import script from "./CampaignStats.vue?vue&type=script&lang=js&"
export * from "./CampaignStats.vue?vue&type=script&lang=js&"
import style0 from "./CampaignStats.vue?vue&type=style&index=0&id=4c45d4f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c45d4f0",
  null
  
)

export default component.exports